import { Provider } from '@angular/core';
import { BimplusWebsdkConfig, BimplusWebSdkFeature } from './interfaces/bimplus-websdk/interfaces';
import { defaultBimplusApiConfigProvider } from './default-providers/default-bimplus-api-config.provider';
import { defaultBimplusApiObjectProvider } from './default-providers/default-bimplus-api-object.provider';
import { defaultBimplusApiTokenProvider } from './default-providers/default-bimplus-api-token.provider';

/**
 * Provides Bimplus API (bimplus-websdk).
 */
export function provideBimplusWebSdk(
  config: BimplusWebsdkConfig,
  ...features: BimplusWebSdkFeature[]
): Provider[] {
  const providers: Provider[] = [
    defaultBimplusApiConfigProvider(config),
    defaultBimplusApiTokenProvider(),
    defaultBimplusApiObjectProvider(),
  ];

  features.forEach(feature => {
    providers.push(...feature.providers);
  });

  return providers;
}
